import PropTypes from "prop-types";
import { InputTextarea } from "primereact/inputtextarea";
import { getErrorMessage } from "../form/FormStandardProps";
import Label from "./Label";

const TextAreaInput = ({
  className = "",
  input,
  label = "",
  meta,
  placeholder = "",
  required = false,
  disabled = false,
  readOnly = false,
  rows = 3,
  cols = 30,
  autoResize = true,
  maxLength,
  infoMessage = "",
  infoPosition = "top",
  ...rest
}) => {
  const { touched, error } = meta || {};

  const { ...inputProps } = input || {};

  const getValue = () => {
    if (disabled && input.value) {
      return input.value;
    } else if (input.value) {
      return input.value;
    } else if (disabled && !input?.value) {
      return "NA";
    }
    return input.value;
  };

  const renderTextAreaInput = () => {
    const value = getValue();
    return (
      <InputTextarea
        {...inputProps}
        id={input.name}
        value={value}
        required={required}
        disabled={disabled || readOnly}
        invalid={touched && error}
        className={`edexlms-field-input w-full ${className}`}
        placeholder={placeholder}
        rows={rows}
        cols={cols}
        autoResize={autoResize}
        maxLength={maxLength}
      />
    );
  };

  return (
    <div
      className={`edexlms-field textarea-input ${readOnly ? "readonly" : ""} ${
        disabled ? "disabled" : ""
      } `}
    >
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
          infoMessage={infoMessage}
          infoPosition={infoPosition}
        />
      )) ||
        null}
      {renderTextAreaInput()}
      {(touched && error && (
        <div className="edexlms-field-error">
          {getErrorMessage(error, input, rest, label || placeholder)}
        </div>
      )) ||
        null}
    </div>
  );
};

TextAreaInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  rows: PropTypes.number,
  cols: PropTypes.number,
  autoResize: PropTypes.bool,
  maxLength: PropTypes.number,
  infoMessage: PropTypes.string,
  infoPosition: PropTypes.oneOf(["top", "bottom", "left", "right"]),
};

export default TextAreaInput;
